import React from "react";

import {
  COHORT_PREVIEW_LONG_RGBA,
  COHORT_PREVIEW_SHORT_RGBA,
  cohortPreviewMarkerShape,
} from "../../../../../utils/cohortTradesResolve";

/**
 * SVG replica of lightweight-charts `arrowUp` / `arrowDown` (see drawArrow),
 * so Trade Review legends match series markers on the chart.
 */
export function TradeReviewChartLegendArrow({
  direction,
  className,
}: {
  direction: "long" | "short";
  className?: string;
}) {
  const up = cohortPreviewMarkerShape(direction) === "arrowUp";
  const fill = direction === "short" ? COHORT_PREVIEW_SHORT_RGBA : COHORT_PREVIEW_LONG_RGBA;
  // Size 12 → halfArrow 5.5, halfBase 3; center (6, 6) in a 12×12 viewBox.
  const d = up
    ? "M0.5 6 L6 0.5 L11.5 6 L9 6 L9 11.5 L3 11.5 L3 6 Z"
    : "M0.5 6 L6 11.5 L11.5 6 L9 6 L9 0.5 L3 0.5 L3 6 Z";

  return (
    <svg
      viewBox="0 0 12 12"
      width={12}
      height={12}
      className={className}
      aria-hidden
      focusable="false"
    >
      <path d={d} fill={fill} />
    </svg>
  );
}
